import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'benefits',
  templateUrl: './benefits.component.html',
  styleUrls: ['./benefits.component.scss']
})
export class BenefitsComponent {
  @Input() isCompany = false;
}
